<template>
    <div class="tccc_ui" ref="alTccc" :style="style" style="position: fixed">
        <template v-if="callType == 4">
            <template v-if="currentStatus=='响铃'">
                <div class="content">
                    <div class="title">手机呼叫中</div>
                    <div class="info">
                        <p>主叫号码:{{ bindTel }}</p>
                    </div>
                    <div class="option">
                        <el-button icon="Phone" type="danger" style="width: 200px;" round @click="sipUnlink">挂断</el-button>
                        <!-- <el-button type="success" round>静音</el-button> -->
                    </div>
                </div>
            </template>
            <template v-if="currentStatus=='通话'">
                <div class="content">
                    <div class="title">通话中</div>
                    <div class="info">
                        <p>主叫号码:{{ bindTel }}</p>
                        <p v-if="customerNumber">呼叫号码:{{ customerNumber }}</p>
                    </div>
                    <div class="option">
                        <el-button icon="Phone" type="danger" style="width: 200px;" round @click="sipUnlink">挂断</el-button>
                        <!-- <el-button type="success" round>静音</el-button> -->
                    </div>
                </div>
            </template>
        </template>
        <template v-if="callType == 1" >
            <div class="content" v-if="currentStatus == '响铃'">
                <div class="title">请求电话接入</div>
                <div class="info">
                    <p v-if="customerNumber">{{ customerNumber }}</p>
                    <p v-if="customerProvince">{{ `${customerProvince}${customerCity}` }}</p>
                </div>
                <div class="option">
                    <el-button icon="Phone" type="primary" style="width: 80px;" round @click="sipLink">接听</el-button>
                    <el-button type="danger" style="width: 80px;" round @click="refuseLink">拒接</el-button>
                    <!-- <el-button type="success" round>静音</el-button> -->
                </div>
            </div>
            <div class="content" v-if="currentStatus == '通话'">
                <div class="title">呼入通话中</div>
                <div class="info">
                    <p v-if="customerNumber">{{ customerNumber }}</p>
                    <p v-if="customerProvince">{{ `${customerProvince}${customerCity}` }}</p>
                </div>
                <div class="option">
                    <el-button icon="Phone" type="danger" style="width: 200px;" round @click="sipUnlink">挂断</el-button>
                    <!-- <el-button type="success" round>静音</el-button> -->
                </div>
            </div>
        </template>
    </div>
</template>

<script setup>
import { ElMessage } from "element-plus";
import { useDraggable } from '@vueuse/core'
import { onMounted, watch } from "vue";
const alTccc = ref(null)
const { x, y, style } = useDraggable(alTccc, {
  initialValue: { x: 800, y: 40 },
})

const currentStatus = ref('')
const bindTel = ref('')
const customerNumber = ref('') //拨打号码
const callType = ref(null) //1 呼入 4 预览外呼,6 主叫外呼,9 内部呼叫
const customerProvince = ref('')
const customerCity = ref('')
watch(currentStatus,(val)=>{
    if(!['呼叫中','通话','响铃'].includes(val)){
        bindTel.value = '';
        customerNumber.value = '';
        customerProvince.value = '';
        customerCity.value = '';
        callType.value = null;
    }
},{
    immediate:true
})
function addEvent(){
        //注册事件处理方法
        /** 状态事件 */
        CTILink.event("status", handleState);  //当前座席状态
        CTILink.event("previewOutcallBridge", handlePreviewOutcallBridge);
        CTILink.event("login", handleLogin);
        /** 其他事件 */
        CTILink.event("ringing", handleRinging); //弹屏
        CTILink.event("kickout", handleKickout);  //被踢下线
}
//退出
function doLogout() {
    let params = {};
    params.logoutMode = 1;
    params.removeBinding = 0;
    CTILink.Agent.logout(params, function(result) {
        if (result.code == 0) {
            //退出成功
            addEventLog('退出成功')
        }
    });
}
function handleLogin(res){
    console.log(res)
}
//处理状态事件
function handleState(event) {
    console.log('当前座席状态',event)
    currentStatus.value = event.state;
    bindTel.value = event.bindTel;
    //座席状态描述 : 离线，失效，空闲，置忙，整理，呼叫中，响铃，通话
    var stateShow = event.state;
    switch (event.state) {
        case '离线':
            break;
        case '失效':
            //软电话状态, 退出
            doLogout();
            break;
        case '空闲':
            break;
        case '置忙':
            break;
        case '呼叫中':
            break;
        case '响铃':
            switch(event.stateAction) {
                case 'ringingIb' : //呼入座席响铃
                    break;
                case 'ringingAgentOb' : //外呼座席响铃
                    break;
                case 'ringingCustomerOb': //外呼客户响铃
                    break;
            }
            break;
        case '通话':
            switch(event.stateAction) {
                case 'busyIb' : //呼入座席接听
                    break;
                case 'busyOb' : //外呼客户接听 客户和座席通话
                    break;
                case 'hold' : //保持开始
                    stateShow = '保持';
                    break;
                case 'unhold' : //保持结束
                    break;
                case 'consultStart' : //咨询开始
                    break;
                case 'consultLink' : //咨询成功
                    stateShow = '咨询';
                    break;
                case 'busyConsult' : //被咨询转接或转移的通话
                case 'busyTransfer' :
                    break;
                case 'consultThreeway':
                    stateShow = '咨询三方';
                default:
            }
            break;
        case '整理':  //整理开始（座席挂断）
            break;
    }
}
function handleRinging(res){
    console.log('弹屏',res)
    callType.value = res.callType;
    customerProvince.value = res.customerProvince;
    customerCity.value = res.customerCity;
    customerNumber.value = res.customerNumber || ""
}
function handleKickout(res){
     console.log('被踢下线',res)
     if (res.code == 0) {
        //被踢下线
        addEventLog('被踢下线')
    }
}
function handlePreviewOutcallBridge(res){
    console.log('预览外呼双方接通',res)
}
//接听
function sipLink(){
    CTILink.SipSession.sipLink();
}
//挂断
function sipUnlink(){
    CTILink.SipSession.sipUnlink();
}
//拒接
function refuseLink(){
    const params = {
        description:"忙碌"
    }
    CTILink.Session.refuse(params, function(res){
        console.log('拒接',res)
    });
}
function addEventLog(msg) {
    ElMessage({
        type: "info",
        message: msg,
    });
}
onMounted(()=>{
    addEvent()
})
</script>

<style lang="scss" scoped>
.tccc_ui{
    width: 280px;
    z-index: 5000;
    color:#fff;
    background-color: #4b4b4bfc;
    border-radius: 8px;
    overflow: hidden;
    box-sizing: border-box;
    font-size: 14px;
    cursor: move;
    .content{
        padding: 12px;
        box-sizing: border-box;
        .title{
            padding-bottom: 8px;
        }
        .info{
            padding: 8px 0;
            p{
                line-height: 24px;
            }
        }
        .option{

        }
    }
}
</style>
